'use client';
import { useRouter } from 'next/router';
const getLocal = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useRouter();
};
export default getLocal;
